import { useEffect, useState } from "react";
import { Tag } from "lucide-react";
import HistoricoVersoesModal from "@/components/HistoricoVersoesModal";
import { fmtVersao } from "@/lib/historicoVersoes";

/**
 * Versão + data/hora da última publicação (padrão do GEDDOC): lida do /version.json, regravado a
 * CADA publicação de front ou back (scripts de deploy). Fica no rodapé do menu do Master e da pista
 * para o usuário e o suporte saberem qual versão está no ar. Clicar abre o histórico de mudanças.
 * `compacto`: só o ícone em telas estreitas (menu do Master no celular), com o texto no title.
 */
export default function AppVersionTag({ compacto = false, className = "" }) {
  const [v, setV] = useState(null);
  const [aberto, setAberto] = useState(false);
  useEffect(() => {
    let ok = true;
    fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (ok && j) setV(j.version ?? j.build ?? null); })
      .catch(() => { /* sem version.json: não mostra nada */ });
    return () => { ok = false; };
  }, []);
  if (!v) return null;
  const versao = fmtVersao(v);
  return (
    <>
      <button type="button" onClick={() => setAberto(true)} data-testid="app-versao"
              title={`Versão ${versao} — ver o histórico de mudanças`}
              className={`flex items-center justify-center gap-1.5 rounded-lg px-2 py-1.5 select-none font-medium cursor-pointer transition-opacity hover:opacity-80 text-neutral-600 ${className}`}
              style={{ background: "rgba(128,128,128,0.10)", border: "1px solid rgba(128,128,128,0.28)" }}>
        <Tag className="w-3.5 h-3.5 shrink-0" />
        <span className={`text-[11px] leading-tight ${compacto ? "hidden md:inline" : ""}`}>
          Versão <b className="font-bold">{versao}</b>
        </span>
      </button>
      <HistoricoVersoesModal open={aberto} onOpenChange={setAberto} versaoAtual={versao} />
    </>
  );
}
